import React from 'react';

import UserMigration, {
  MigrationEmailType,
  MigrationType,
} from 'app/developer-v3/components/UserMigration';

import VersionModalWrapper from './VersionModalWrapper';

type Props = {
  email: string;
  fromVersion?: string;
  isSaving: boolean;
  numUsers: number;
  onChangeEmail: (value: string) => void;
  onChangeEmailType: (value: MigrationEmailType) => void;
  onChangePercentage: (value: number) => void;
  onChangeType: (value: MigrationType) => void;
  onConfirm: () => void;
  onClose: () => void;
  onSetFromVersion: (value: { value: string }) => void;
  onSetToVersion: (value: { value: string }) => void;
  percentage: number;
  toVersion?: string;
  type: MigrationType;
  versions: string[];
};

const Migrate = (props: Props) => {
  const {
    email,
    fromVersion,
    isSaving,
    numUsers,
    onChangeEmail,
    onChangeEmailType,
    onChangePercentage,
    onChangeType,
    onClose,
    onConfirm,
    onSetFromVersion,
    onSetToVersion,
    percentage,
    toVersion,
    type,
    versions,
  } = props;

  return (
    <VersionModalWrapper
      confirmButtonDisabled={!toVersion || (type === 'email' && email === '')}
      confirmButtonLabel="Migrate"
      description="After completing and testing the new version of your integration, migrate users from your existing integration to the new version. You can migrate a specific user, a percentage of users, or all users at once."
      heading="Migrate User(s)"
      isSaving={isSaving}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <UserMigration
        email={email}
        fromVersion={fromVersion}
        numUsers={numUsers}
        onChangeEmail={onChangeEmail}
        onChangeEmailType={onChangeEmailType}
        onChangePercentage={onChangePercentage}
        onChangeType={onChangeType}
        onSetFromVersion={onSetFromVersion}
        onSetToVersion={onSetToVersion}
        percentage={percentage}
        toVersion={toVersion}
        type={type}
        versions={versions}
      />
    </VersionModalWrapper>
  );
};

Migrate.defaultProps = {
  email: '',
  percentage: 100,
};

export default Migrate;
